/*
 * @Author: your name
 * @Date: 2021-12-02 14:28:33
 * @LastEditTime: 2024-12-17 15:26:35
 * @LastEditors: zhangyuan your_email
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /report-template/src/store/mutation-types.ts
 */
export default {
    SAVE_PHOTO_INFO:'SAVE_PHOTO_INFO',
    SAVE_DATA_INFO:'SAVE_DATA_INFO',
    SAVE_REPORT_DETECT_VERSION:'SAVE_REPORT_DETECT_VERSION',
    SAVE_IS_DISPLAY:'SAVE_IS_DISPLAY',
    SAVE_OPACITY_STYLE: 'SAVE_OPACITY_STYLE',
    SAVE_CHECK_ITEM_SHOW: 'SAVE_CHECK_ITEM_SHOW',
    SAVE_IDLE_FISH_INFO: 'SAVE_IDLE_FISH_INFO',
    SAVE_TOCONLYSHOWFLAW: 'SAVE_TOCONLYSHOWFLAW',
    SAVE_PAGESCROLLTOP: 'SAVE_PAGESCROLLTOP',
    SAVE_ISNORMAL: 'SAVE_ISNORMAL',
    SAVE_REPORTRESULTLIST: 'SAVE_REPORTRESULTLIST',
    SAVE_VERSION240530: 'SAVE_VERSION240530',
    SAVE_VERSION240702: 'SAVE_VERSION240702',
    SAVE_VERSION240704: 'SAVE_VERSION240704',
    SAVE_VERSION240326: 'SAVE_VERSION240326',
    SAVE_VERSION241226: 'SAVE_VERSION241226',
    SAVE_VERSION250218: 'SAVE_VERSION250218',
}
